import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchExpenses(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/expenses', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchExpense(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/expenses/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addExpense(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/expenses`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteExpense(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/expenses/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateExpense(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/expenses/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchEnrollments(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/enrollments', {params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchStudents(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/students', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}